import { ThemeProvider, createTheme } from '@mui/material/styles';
import Router from 'kosmos/router';
import ContentProvider from 'ContentProvider';

import './kosmos.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#23c8a7',
      contrastText: '#fff',
    },
    secondary: {
      main: '#0b4388',
      contrastText: '#fff',
    },
  },
});

export default function KosmosApp(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <ContentProvider>
        <Router />
      </ContentProvider>
    </ThemeProvider>
  );
}
